const getElementWithInlineStyles = (element) => {
    const baseline = document.createElement(element.tagName);
    document.body.appendChild(baseline);
    const defaultStyle = window.getComputedStyle(baseline);

    const clone = element.cloneNode(true);

    function inlineStyles(source, target) {
        const computed = window.getComputedStyle(source);
        let styleString = "";
        for (let i = 0; i < computed.length; i++) {
            const prop = computed[i];
            const value = computed.getPropertyValue(prop);
            if (value !== defaultStyle.getPropertyValue(prop)) {
                styleString += `${prop}: ${value}; `;
            }
        }
        if (styleString) target.setAttribute("style", styleString);

        for (let i = 0; i < source.children.length; i++) {
            inlineStyles(source.children[i], target.children[i]);
        }
    }

    inlineStyles(element, clone);
    document.body.removeChild(baseline);
    return clone.outerHTML;
};

function imageToBase64AtSize(src, width, height) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = reject;
        img.src = src;
    });
}

const getElementWithInlineStylesAsync = async (element) => {
    const baseline = document.createElement(element.tagName);
    document.body.appendChild(baseline);
    const defaultStyle = window.getComputedStyle(baseline);

    const clone = element.cloneNode(true);

    function inlineStyles(source, target) {
        const computed = window.getComputedStyle(source);
        let styleString = "";
        for (let i = 0; i < computed.length; i++) {
            const prop = computed[i];
            const value = computed.getPropertyValue(prop);
            if (value !== defaultStyle.getPropertyValue(prop)) {
                styleString += `${prop}: ${value}; `;
            }
        }
        if (styleString) target.setAttribute("style", styleString);

        for (let i = 0; i < source.children.length; i++) {
            inlineStyles(source.children[i], target.children[i]);
        }
    }

    inlineStyles(element, clone);
    document.body.removeChild(baseline);

    // Replace every <img> src with a base64 data URL sized to what is
    // actually rendered on screen (offsetWidth/Height), falling back to
    // the image's natural dimensions when the element has no layout size.
    const sourceImgs = Array.from(element.querySelectorAll('img'));
    const cloneImgs = Array.from(clone.querySelectorAll('img'));

    await Promise.all(sourceImgs.map(async (srcImg, i) => {
        const cloneImg = cloneImgs[i];
        if (!cloneImg) return;
        const w = srcImg.offsetWidth || srcImg.naturalWidth;
        const h = srcImg.offsetHeight || srcImg.naturalHeight;
        if (!w || !h) return;
        try {
            cloneImg.src = await imageToBase64AtSize(srcImg.src, w, h);
            cloneImg.setAttribute('width', w);
            cloneImg.setAttribute('height', h);
        } catch {
            // keep the original src as fallback
        }
    }));

    return clone.outerHTML;
};

export { getElementWithInlineStyles, getElementWithInlineStylesAsync }
